import { StudyPlanProgressModel } from "../../../../../types/gqlTypes/graphql"
import { EocClientStudyPlan } from "../../../types"

export const getStudentStudyPlanProgressModel = (
  plan: EocClientStudyPlan
): StudyPlanProgressModel => {
  if( !(plan?.meta?.isPlanBuilt ?? false) ) {
    return {
      completed: 0,
      inProgress: 0,
      notStarted: 0,
      percentCompleted: 0,
      percentInProgress: 0,
      percentNotStarted: 0
    }
  }
  const statesCount = plan.sections
    .map(section => section.items)
    .flat()
    .reduce(
      (res, item) => ({
        ...res,
        ...(item.status === "COMPLETE" && { completed: res.completed + item.totalSeconds }),
        ...(item.status === "IN_PROGRESS" && {
          inProgress: res.inProgress + item.totalSeconds
        }),
        ...(item.status === "NOT_STARTED" && {
          notStarted: res.notStarted + item.totalSeconds
        })
      }),
      {
        completed: 0,
        inProgress: 0,
        notStarted: 0
      }
    )

  const total =
    statesCount.completed + statesCount.inProgress + statesCount.notStarted

  return {
    ...statesCount,
    ...(!!total
      ? {
          percentCompleted: (statesCount.completed / total) * 100,
          percentInProgress: (statesCount.inProgress / total) * 100,
          percentNotStarted: (statesCount.notStarted / total) * 100
        }
      : {
          percentCompleted: 0,
          percentInProgress: 0,
          percentNotStarted: 0
        })
  }
}
